module.exports = __webpack_public_path__ + "static/media/asset_mobile_tablet_UI_2.dc986d81.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Features/Watch/img/asset_mobile_tablet_UI_2.png
// module id = 174
// module chunks = 0